module.exports = __webpack_public_path__ + "static/img/cont40_06.8aa8b5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont40_06.jpg
// module id = SCKM
// module chunks = 0